import React from 'react';

export type WrapperProps = {
  children?: React.ReactNode;
  className?: string;
};

export default function Wrapper(props: WrapperProps) {
  const { children, className } = props;
  return <div className={'bg-white border border-neutral-300 mb-2 p-3 rounded ' + className}>{children}</div>;
}
